import { createFileRoute } from "@tanstack/react-router";
import { useAdminAuth } from "@/features/admin/hooks/useAdminAuth";
import { AdminShell } from "@/features/admin/shell/AdminShell";
import { AdminPageHeader } from "@/features/admin/shell/AdminPageHeader";
import { PlayerAnalyticsDashboard } from "@/features/admin/analytics/components/PlayerAnalyticsDashboard";
import { useT } from "@/shared/i18n/LocaleContext";

export const Route = createFileRoute("/_adminGuarded/admin/analytics")({
  component: AdminAnalyticsPage,
});

function AdminAnalyticsPage() {
  const t = useT();
  const { state } = useAdminAuth();
  const token = state.status === "authenticated" ? state.token : null;

  return (
    <AdminShell breadcrumbs={[{ label: t("admin.analytics.title") }]}>
      <AdminPageHeader
        title={t("admin.analytics.title")}
        subtitle={t("admin.analytics.subtitle")}
      />

      {token ? <PlayerAnalyticsDashboard token={token} /> : null}
    </AdminShell>
  );
}
